import { Language, ModelLanguage } from 'modules/EntityReference/CodeSnippets';
import { BashSnippets, llmSnippets } from './snippetMapping';

export const getCodeSnippetBy = (language: Language) => {
  return llmSnippets[language]?.({ apiHost: '', appId: '', inputUrl: '', modelId: '', modelVersionId: '', pat: '', userId: '' }) ?? '';
};

export const getBashSnippet = (language: ModelLanguage) => {
  const key = language as unknown as keyof typeof BashSnippets;
  return BashSnippets?.[key]?.() ?? '# No Installation Required';
};

export const getAuthenticatedSnippet = (language: Language) => {
  return llmSnippets[language];
};
